export default __webpack_public_path__ + "assets/6072546ffaa9af5027a44f2a4a6e9ebd.jpeg";